<template>
  <FormulateInput
    type="datepicker"
    class="input-date"
    placeholder="Selecciona una fecha"
    language="es"
    first-day-of-week="mon"
    :typeable="true"
    :format="customFormatter"
    :parser="customParser"
    :disabled-dates="disabledDates"
    v-bind="context.attributes"
    v-model="context.model"
  >
  </FormulateInput>
</template>
<script>
import { format, parse } from 'date-fns';
import { MAXAGE } from '@/constants/age';

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
    };
  },
  computed: {
    disabledDates() {
      return (
        this.context.attributes.disabledDates ?? {
          to: this.oldest,
        }
      );
    },
    youngest() {
      var youngest = new Date();
      youngest.setFullYear(youngest.getFullYear() + MAXAGE);
      return youngest;
    },
    oldest() {
      const oldest = new Date();
      oldest.setFullYear(oldest.getFullYear() - MAXAGE);
      oldest.setDate(oldest.getDate() - 1);
      return oldest;
    },
  },
  methods: {
    customFormatter(date) {
      return format(date, this.format);
    },
    customParser(date) {
      const [day, month, year] = date.split('/');
      if (!!year && year.length > 3 && this.isAncientDate(year, month, day)) {
        const res = parse(new Date(this.youngest).getDate(), this.format, new Date());
        return res;
      }
      return parse(date, this.format, new Date());
    },
    isAncientDate(year, month, day) {
      const oldest = new Date(this.oldest).getTime();
      const ancient = new Date(year, day || '01', month || '01').getTime();
      return oldest > ancient;
    },
  },
};
</script>
